import Image from 'next/legacy/image';
import Link from 'next/link';
import React from 'react';
import { BodyRegular, H1 } from '@components/atoms/typography';
import Button from '@components/atoms/button';
import { InfoAlert } from '@components/alert';

const ErrorFallback = () => {
  return (
    <div className="flex flex-col items-center py-10 px-5 max-w-[700px] mx-auto">
      <Image
        src="/images/pep.jpg"
        height={333}
        width={500}
        alt="Page error image"
        className="rounded-lg"
      />
      <H1 className="text-center mt-6">Even Pep makes mistakes</H1>
      <BodyRegular className="text-center mt-1">
        You've encountered an error. Our tech team are aware of this and are
        working on a fix.
      </BodyRegular>
      <div className="my-3">
        <InfoAlert text="Did you know that most issues can be resolved by logging out and logging in again? Before reaching out for support, please give this a try." />
      </div>
      <BodyRegular className="text-center mt-1">
        You can also visit our support centre{' '}
        <Link
          href="https://fantasyfootballhub.freshdesk.com/support/home"
          className="text-primary-600 underline"
          target="_blank"
        >
          here
        </Link>
        .
      </BodyRegular>
      <Button href="/" isLink variant="primary" className="mt-4">
        Return to home
      </Button>
    </div>
  );
};

export default ErrorFallback;
